import { Box, CircularProgress } from '@mui/material';
import { AUTH_COLORS } from '../pages/auth/authTheme';

/** Full-screen blur overlay — same as login submit loading. */
export default function AppLoadingOverlay() {
  return (
    <Box
      sx={{
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
        backdropFilter: 'blur(6px)',
        backgroundColor: 'rgba(255,255,255,0.35)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <CircularProgress size={52} thickness={3} sx={{ color: AUTH_COLORS.green }} />
    </Box>
  );
}
